import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PageLoadingIndicator } from '@kioskgaming/page-loading';
import { useAuth } from '../../hooks/useAuth';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#fafafa]">
        <PageLoadingIndicator variant="section" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
